namespace GeniuzPOS.AdvPromo {
    export interface PsPromoAvMbRow {
        Id?: number;
        PmGroupId?: string;
        MbType?: string;
    }

    export namespace PsPromoAvMbRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmGroupId';
        export const localTextPrefix = 'AdvPromo.PsPromoAvMb';
        export const lookupKey = 'AdvPromo.PsPromoAvMb';

        export function getLookup(): Q.Lookup<PsPromoAvMbRow> {
            return Q.getLookup<PsPromoAvMbRow>('AdvPromo.PsPromoAvMb');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmGroupId = "PmGroupId",
            MbType = "MbType"
        }
    }
}
